import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

export const BalloonContainer = styled.View`
  position: relative;
  background-color: ${({theme}) => theme.colors.yellow};
  padding: ${RFValue(6)}px ${RFValue(10)}px;
  border-radius: ${RFValue(12)}px;
  max-width: ${RFValue(165)}px;
  min-height: ${RFValue(32)}px;
  justify-content: center;
`;

export const BalloonText = styled.Text`
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BalloonTail = styled.View`
  position: absolute;
  width: 0px;
  height: 0px;
  border-left-width: ${RFValue(6)}px;
  border-right-width: ${RFValue(6)}px;
  border-top-width: ${RFValue(10)}px;
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: ${({theme}) => theme.colors.yellow};
  right: ${RFValue(12)}px;
  bottom: ${RFValue(-7)}px;
`;
